import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chart_theme_selector = _resolveComponent("chart-theme-selector");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  return _openBlock(), _createBlock(_component_app_dropdown, {
    class: "chart-theme-dropdown"
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_chart_theme_selector, {
      theme: $props.modelValue
    }, null, 8, ["theme"])]),
    body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.themes, (theme, index) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: index
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(theme.name), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(theme.accents, (accent, index) => {
        return _openBlock(), _createBlock(_component_b_dropdown_item, {
          key: index,
          onClick: $event => _ctx.$emit('update:modelValue', accent)
        }, {
          default: _withCtx(() => [_createVNode(_component_chart_theme_selector, {
            theme: accent
          }, null, 8, ["theme"])]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))], 64);
    }), 128))]),
    _: 1
  });
}